// src/types.ts
var MosaicDragType = {
  WINDOW: "MosaicWindow"
};
export {
  MosaicDragType
};
